<style lang="less" rel="stylesheet/less" scope>
  .platform {
    header {
      height: 62px;
      line-height: 62px;
      padding: 0 30px;
      background-color: #00A1E9;
    }
    .login-title {
      display: inline-block;
      float: right;
      color: #fff;
      font-size: 16px;
    }
    .logout {
      color: #fff;
    }
  }
</style>
<template>
  <div class="platform">
    <header class="header">
      <div class="top-nav-header clearfix">
        <div class="top-nav-info pull-left">
          <a href="javascript:void(0);">
            <img src="./../../assets/homepage/log.png">
            <span class="login-title">统一用户中心</span>
          </a>
        </div>
        <a v-if="hasLogout" href="javascript:;" @click="logout" class="logout fr">
          <i class="el-icon-fa-power-off"></i>
          退出
        </a>
      </div>
    </header>
    <slot></slot>
  </div>
</template>
<script type='text/ecmascript-6'>
  import logOutMixin from '@/components/layout/logout-mixin';
  export default {
    name: 'LyLayoutPlatform',
    mixins: [logOutMixin],
    props: {
      hasLogout: {
        type: Boolean,
        default: false
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/layout-platform/index.vue